import ChipSelect from './chip-select';
import { useChipSelect } from './chip-select-hooks';
export default ChipSelect;
export { useChipSelect };
